// extracted by mini-css-extract-plugin
export default {"component":"bq2C_r","icon":"cq2C_r","message":"dq2C_r"};